import { createContext, useContext, useState, useCallback, useRef } from 'react';
import useIsMobile from '../hooks/FJSsrPreview/FJAIBanners/useIsMobile';

const ModalContext = createContext(null);

export function ModalProvider({ children }) {
    const [showModal, setShowModal] = useState(false);
    const resolverRef = useRef(null);
    const { isMobile } = useIsMobile();

    const openModal = useCallback(() => {
        const hasPopedUp = sessionStorage.getItem('hasPopedUpAppDownloadModal');
        if (hasPopedUp || !isMobile) {
            return;
        }
        sessionStorage.setItem('hasPopedUpAppDownloadModal', true);
        setShowModal(true);
        return new Promise(resolve => {
            resolverRef.current = resolve;
        });
    }, [isMobile]);

    const closeModal = useCallback(() => {
        setShowModal(false);
        if (resolverRef.current) {
            resolverRef.current();
            resolverRef.current = null;
        }
    }, []);

    return (
        <ModalContext.Provider value={{ showModal, openModal, closeModal }}>
            {children}
        </ModalContext.Provider>
    );
}

export function useAppDownloadModal() {
    const ctx = useContext(ModalContext);
    if (!ctx) throw new Error('useAppDownloadModal 必须在 ModalProvider 内使用');
    return ctx;
}
